import React, { Component } from 'react';
import Search from '../common/Search';

class MobileHeaderSearch extends Component {
  constructor() {
    super();
    this.state = {
      searchedValue: '',
    };
    this.setSearchedValue = this.setSearchedValue.bind(this);
  }
  componentWillMount() {
    if (!(this.props.commonReducer && this.props.commonReducer.autoSuggestedList && this.props.commonReducer.autoSuggestedList.length)) {
      this.props.actions.getAutosuggestedList();
    }
  }

  setSearchedValue(text) {
    this.setState({ searchedValue: text });
  }

  render() {

    return (
      <div className="n-mob-search header-search">
        <a><i className="mdi mdi-arrow-left" onClick={this.props.mobSearchClick}> </i></a>
        <Search closeSearchPopup={() => { this.props.mobSearchClick(); }} setSearchedValue={() => this.setSearchedValue} searchedValue={this.state.searchedValue} actions={this.props.actions} noAutoSuggestCall="true" commonReducer={this.props.commonReducer} />


      </div>
    );
  }
}

export default MobileHeaderSearch;



// WEBPACK FOOTER //
// ./src/components/common/MobileHeaderSearch.jsx